import React, { useEffect, useReducer } from "react";
import Navigation, { NavLink } from "@acadia-ui/navigation";
import CookieHelpers from "./../Auth/CookieHelpers";
import UnderConstruction from "../UnderConstruction";
import useViewMasterCampaigns from "../../Views/ViewMasterCampaigns";
import useWorkbook from "../../Views/WorkbookV2";
import useActivityLog from "../../Views/ActivityLog";
import FourOhFour from "../../Views/FourOhFour";
import CrossPlatformQA from "../../Views/CrossPlatformQA";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import "./NavigationWrapper.scss";

const NavigationWrapper = () => {
	// TODO: review this old logout logic and see if it's still needed
	useEffect(() => {
		const handleLogout = () => {
			CookieHelpers.deleteCookie("authToken");
			CookieHelpers.deleteCookie("userRoles");
			CookieHelpers.deleteCookie("userFeatures");
			sessionStorage.clear();
		};

		const logout = document.querySelectorAll("a[href='/logout']");
		logout.forEach((button) => {
			button.addEventListener("click", handleLogout);
		});

		return () => {
			logout.forEach((button) => {
				button.removeEventListener("click", handleLogout);
			});
		};
	}, []);

	const navigate = useNavigate();
	const { pathname } = useLocation();

	const [page, dispatchChangePage] = useReducer((_, value) => {
		const page = value?.split("/")?.[1] || "";
		const newValue = (page == "" ? "home" : page || "home")?.toLowerCase?.();
		return newValue;
	}, "home");

	// if the user types in the browser navigation bar manually, update our state
	useEffect(() => {
		dispatchChangePage(pathname);
	}, [pathname]);

	// these are hooks because sokme values are dynamic based on downstream data
	const viewMasterCampaigns = useViewMasterCampaigns();
	const workbook = useWorkbook();
	// const workbook = {};
	const activityLog = useActivityLog();

	// routes
	const pages = {
		home: {
			exact: true,
			showNavLink: true,
			path: "/",
			...viewMasterCampaigns,
			label: "Campaigns"
		},
		workbook: {
			path: "/workbook",
			showBack: true,
			onBackClick: () => navigate("/"),
			...workbook
		},
		activitylog: {
			showNavLink: true,
			path: "/activitylog",
			label: "Activity Log",
			...activityLog
		},
		crossplatformqa: {
			showBack: true,
			label: "Cross Platform QA",
			path: "/crossplatformqa/:campaignId",
			element: <CrossPlatformQA />
		}
		// help: {
		// 	showNavLink: true,
		// 	path: "/help",
		// 	label: "Help",
		// 	element: <UnderConstruction />
		// }
	};

	const { label, subNavLinks, showBack, onBackClick, actions } = pages[page] || {};

	return (
		<>
			<Navigation
				className="navigation-container"
				heading={label}
				subnavLinks={subNavLinks || []}
				showBack={showBack || false}
				onBackClick={onBackClick}
				actions={actions || <div key="action-portal-container" id="navigation-action-portal-target-container" />}
				navLinks={
					Object.entries(pages)
						?.filter(([_, { showNavLink }]) => showNavLink)
						?.map(([key, { path, label }]) => (
							<NavLink
								// this comment exists to prevent eslint from making this unreadable.
								as={Link}
								key={key}
								to={path}
								onClick={() => dispatchChangePage(key)}
								selected={page === key}
							>
								{label} {page === key && <i className="icon-checkmark" />}
							</NavLink>
						)) || []
				}
			/>
			<Routes>
				{Object.entries(pages).map(([key, { label, caseSensitive = false, ...rest }]) => (
					<Route key={key} {...rest} caseSensitive={caseSensitive} />
				))}
				<Route Component={FourOhFour} />
			</Routes>
		</>
	);
};

export default NavigationWrapper;
